// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__9pHAI","load8":"styles_load8__P1GPK"};